export const getSorter =
  <T>(valueAccessor: (item: T) => any) =>
  (left: T, right: T) => {
    if (valueAccessor(left) === valueAccessor(right)) {
      return 0;
    }

    return valueAccessor(left) > valueAccessor(right) ? 1 : -1;
  };
